import { put, call, takeEvery } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { Lesson } from '../types'
import { EXTEND_LESSON, EXTEND_LESSON_SUCCESS, EXTEND_LESSON_FAIL, ExtendLessonAction } from '../redux/lessonReducer'

function* ExtendLessonFlow(action: ExtendLessonAction): Generator<any, void, any> {
  try {
    const response: Lesson = yield call(apiCall, {
      endpoint: `/tutors/lessons/${action.payload.id}/extend_duration`,
      method: 'POST',
      params: {}
    })
    yield put(EXTEND_LESSON_SUCCESS(response))
  } catch (error) {
    yield put(EXTEND_LESSON_FAIL())
    console.log(error)
  }
}

export default function* ExtendLessonSaga(): Generator<any, void, any> {
  yield takeEvery([EXTEND_LESSON], ExtendLessonFlow)
}
